import { Chip } from '@mui/material';
import React from 'react';
import { AssessmentSessionProcessTypeId } from '../../../services/exams/assessmentSession/assessments.types';
import { getProcessLabel } from '../../../utils/assessmentSessionProcess';
import { SampleAssessmentSessionState, SessionType } from '../Dashboard.types';

export const RgzChipStatus: React.FC<{
  processState: AssessmentSessionProcessTypeId;
  sessionType?: SessionType;
  sampleAssessmentSessionStateId?: SampleAssessmentSessionState;
}> = ({ processState, sessionType, sampleAssessmentSessionStateId }) => {
  const label = getProcessLabel(processState);
  const isZWOsession = sessionType === SessionType.SampleAssessmentSession;
  const chipLabel =
    sessionType === SessionType.SampleAssessmentSession ? (
      <>
        {`Zespół wzorcowych ocen ${
          sampleAssessmentSessionStateId === SampleAssessmentSessionState.Closed ? ' - praca zakończona' : '(ZWO)'
        }`}
      </>
    ) : (
      `${label.label} w toku`
    );
  // TEMPORARY WE SHOW ONLY CHIPS FOR ZWO SESSION, FINAL GOAL IS TO GET STATUS AND NAME OF THE ACTUAL PROCESS
  return isZWOsession ? (
    <Chip sx={{ height: '25px' }} label={chipLabel} variant="outlined" />
  ) : (
    <div style={{ height: 25 }}></div>
  );
};
